/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Utils\Pricing.ts
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Tuesday September 3rd 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday September 3rd 2024 8:52:47 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { PricingType, PriceListsByType } from "Types/pricing.type";

export function formatPricing(data: PricingType[]) {
    const result: PriceListsByType = data.reduce((acc: PriceListsByType, curr: PricingType) => {
        const typeKey = curr.Type;
        if (!acc[typeKey][curr.Mileage])
            acc[typeKey][curr.Mileage] = {};

        acc[typeKey][curr.Mileage][curr.Month] = curr.Amount;
        return acc;
    }, { LOA: {}, LLD: {} });
    return result;
};
